import { useContext, useState, useRef } from 'react';

import { Popover, message } from 'antd';

import { cartAddOverseas, cartAddNormal } from '@/apis/cart';
import { asyncCheckNoPriceEnquiry } from '@/apis/order';
import PriceInquiryModal from '@/components/PriceInquiryModal';
import { LayoutContext } from '@/layouts/baseLayout/provider';
import { ProductItemContext } from '@/providers/productItem';
import { ProductListContext } from '@/providers/productList';
import useUserStore from '@/store/user';
import { buriedPoint } from '@/utils/buriedPoint';
import lcMsgTips from '@/utils/lcMsgTips';
import Parabola from '@/utils/parabola';
import Utils from '@/utils/Utils';

export default function PurchuseButton(props) {
  const { productVO } = props;
  if (productVO?.shiftStatus === 1) {
    return <ShiftingButton />;
  } else if (
    productVO?.productUnsealVendition === 'no' ||
    (['sold_out', 'stop_product'].includes(productVO?.productCycle) && productVO.productStockStatus === 'no')
  ) {
    return <UnsealedButton {...props} />;
  } else if (productVO?.isShowPrice === false && productVO?.productUnsealVendition !== 'no') {
    return <PriceInquiryButton {...props} />;
  } else if (productVO?.selfProductCode) {
    return <BookedButton {...props} />;
  } else {
    return <AddCartButton {...props} />;
  }
}

export function PriceInquiryButton(props) {
  const { userInfo } = useUserStore();
  const { useInputCount, totalStockNumber } = props;

  const [showPriceInquiryModal, setShowPriceInquiryModal] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);

  const changePriceInquiryModal = (value) => {
    setShowPriceInquiryModal(value);
  };

  const handleAskPrice = async () => {
    if (userInfo?.customerLogin !== 1) {
      Utils.showWindowLogin();
      return false;
    }
    let params;
    if (props?.productVO?.selfProductCode) {
      // 判断是否P转C
      params = {
        selfProductCode: props?.productVO?.selfProductCode,
        selfProductId: props?.productVO?.selfProductId,
        provider: props?.productVO?.lcBookProductVO?.provider,
        productCodeProvider: props?.productVO?.lcBookProductVO?.productCodeProvider,
        productCodeManufacturer: props?.productVO?.lcBookProductVO?.productCodeManufacturer,
        vendorCode: props?.productVO?.lcBookProductVO?.vendorCode,
      };
    } else if (props?.productVO?.provider) {
      // 存在provider即为订货或海外代购
      params = {
        provider: props?.productVO?.provider,
        productCodeProvider: props?.productVO?.productCodeProvider,
        productCodeManufacturer: props?.productVO?.productCodeManufacturer,
        vendorCode: props?.productVO?.vendorCode,
      };
    } else {
      // 现货
      params = {
        productId: props?.productVO?.productId,
        productCode: props?.productVO?.productCode,
      };
    }
    const res = await asyncCheckNoPriceEnquiry(params);
    if (res?.needLogin || res?.msg === 'needLogin') {
      Utils.showWindowLogin();
      return false;
    }
    if (res?.code === 200) {
      setCurrentItem(props?.productVO);
      changePriceInquiryModal(true);
    } else {
      lcMsgTips.showConfirmModal({
        title: res?.msg,
      });
    }
  };

  return (
    <>
      <button
        className="mb-[6px] h-[32px] w-full rounded-[6px] text-[12px] border-[1px] border-solid border-[#1FA0E8] bg-[#EDF9FF] text-[#1FA0E8] hover:border-[#0093E6] hover:bg-[#0093E6] hover:text-[white]"
        type="primary"
        onClick={handleAskPrice}
      >
        我要询价
      </button>
      {showPriceInquiryModal && (
        <PriceInquiryModal
          showModal={showPriceInquiryModal}
          changeShowModal={changePriceInquiryModal}
          purchaseCount={useInputCount}
          currentItem={currentItem}
          totalStockNumber={totalStockNumber}
        />
      )}
    </>
  );
}
// 迁移中
export function ShiftingButton() {
  const content = <div className="p-[10px_10px_15px_10px]"></div>;
  return (
    <Popover content={content} overlayClassName="lcsc-popover-wrapper">
      <button className="mb-[6px] block h-[32px] w-full cursor-not-allowed rounded-[6px] bg-[#BABABA] p-[0] text-[14px] text-[white]">
        迁移中
      </button>
    </Popover>
  );
}

// 停售
export function UnsealedButton(props) {
  const { replaceProductId, isMro } = props;
  const [open, setOpen] = useState(false);
  const { resourceData } = useContext(LayoutContext);

  function openChange(value) {
    if (!replaceProductId) {
      return;
    }
    setOpen(value);
  }

  const content = (
    <div className="p-[10px_10px_15px_10px]">
      <span className="text-[#444]">有替代商品</span>
      <a
        className="text-[rgb(0,147,230)]"
        href={`${resourceData?.projectConfigVO?.lcscItemUrl}/${isMro ? 'mro/' : ''}${replaceProductId}.html`}
      >
        点击查看
      </a>
    </div>
  );

  return (
    <Popover content={content} open={open} onOpenChange={openChange} overlayClassName="lcsc-popover-wrapper">
      <button className="mb-[6px] block h-[32px] w-full cursor-not-allowed rounded-[6px] bg-[#BABABA] p-[0] text-[14px] text-[white]">
        停售
      </button>
    </Popover>
  );
}

// 订货
export function BookedButton(props) {
  const { productVO, purchaseCount, totalPrices, suggest = '' } = props;
  const { searchResult, track_zone } = useContext(ProductListContext);
  const { index, rs_log, newParameterCondition } = useContext(ProductItemContext);
  const [loading, setLoading] = useState(false);
  const { userInfo, updateUserInfo } = useUserStore();
  const addBtnRef = useRef(null);

  function bookGoods() {
    if (!props?.validate(purchaseCount)) {
      return;
    }
    if (loading) {
      return;
    }
    setLoading(true);
    const { spm, lcsc_vid } = Utils.getButtonParams(addBtnRef.current);
    cartAddOverseas({
      purchaseNumber: purchaseCount / productVO?.theRatio,
      provider: productVO?.lcBookProductVO?.provider,
      productCodeProvider: productVO?.lcBookProductVO?.productCodeProvider,
      vendorCode: productVO?.lcBookProductVO?.vendorCode,
      batchNumber: productVO?.lcBookProductVO?.batchNumber,
      productRegion: productVO?.lcBookProductVO?.productRegion,
      placeOfOrigin: productVO?.lcBookProductVO?.placeOfOrigin,
      productCodeManufacturer: productVO?.lcBookProductVO?.productCodeManufacturer,
      sourcePartId: productVO?.sourcePartId,
      selfProductCode: productVO?.productCode,
      trackZone: track_zone,
      lcscVid: lcsc_vid,
      spm,
    })
      .then((res) => {
        if (res?.shifting) {
          message.error(res?.shifting);
        } else if (res.needLogin || res.msg === 'needLogin') {
          Utils.showWindowLogin();
          return;
        } else if (res?.code === 200) {
          message.success('加入购物车成功！');
          addCartBall(addBtnRef.current, () => {
            updateUserInfo({
              ...userInfo,
              cartNum: res?.result?.cart_contains_count,
            });
          });
        }
      })
      .finally(() => {
        setLoading(false);
        const params = {
          pc: productVO?.productId,
          brand: productVO?.productGradePlateName,
          model: productVO?.productModel,
          code: productVO?.productCode,
          kw: searchResult?.globalSearchKeyword,
          cp: searchResult?.currePage,
          ix: 0,
          no: purchaseCount,
          price: totalPrices,
          track_zone: track_zone,
          type: 'main_products',
          kind: 'order',
          ixz: index,
          rs_log,
          parameter_condition: newParameterCondition,
        };
        if (suggest) {
          Object.assign(params, {
            suggest,
          });
        }
        buriedPoint({
          op: 'ADD_CART',
          data: params,
        });
      });
  }

  return (
    <button
      ref={addBtnRef}
      className="mb-[6px] block h-[32px] w-full rounded-[6px] border-[1px] border-solid border-[#1FA0E8] bg-[#EDF9FF] text-[14px] text-[#1FA0E8]
      hover:border-[#0093E6] hover:bg-[#0093E6] hover:text-[white]"
      onClick={bookGoods}
      data-spm="iad"
    >
      我要订货
    </button>
  );
}

// 加入购物车
export function AddCartButton(props) {
  const { productVO, purchaseCount, totalPrices, suggest = '', isMro } = props;
  const { searchResult, track_zone } = useContext(ProductListContext);
  const { index, rs_log, newParameterCondition } = useContext(ProductItemContext);
  const { userInfo, updateUserInfo } = useUserStore();
  const [loading, setLoading] = useState(false);
  const addBtnRef = useRef(null);

  function addCart() {
    if (productVO?.productCycle === 'stop_product' && productVO.productStockStatus === 'no') {
      message.error('该商品已停售，不支持订货');
      return;
    }
    if (!props?.validate(purchaseCount)) {
      return;
    }
    if (loading) {
      return;
    }
    const convesionRatio = productVO?.convesionRatio < 1 ? 1 : productVO?.convesionRatio;
    const cartKeyStr = `0~${productVO?.productId}~RMB~CN~${purchaseCount / convesionRatio}`;
    setLoading(true);
    const { spm, lcsc_vid } = Utils.getButtonParams(addBtnRef.current);
    cartAddNormal({
      cartKeyStr,
      entryType: 'product_choose_buy',
      trackZone: track_zone,
      lcscVid: lcsc_vid,
      spm,
    })
      .then((res) => {
        if (res?.needLogin || res?.msg === 'needLogin') {
          Utils.showWindowLogin();
        } else if (res?.shifting) {
          message.error(res?.shifting);
        } else if (res?.code === 200) {
          message.success('加入购物车成功！');
          addCartBall(addBtnRef.current, () => {
            updateUserInfo({
              ...userInfo,
              cartNum: res?.result?.cart_contains_count,
            });
          });
        }
      })
      .finally(() => {
        setLoading(false);
        const params = {
          pc: productVO?.productId,
          brand: productVO?.productGradePlateName,
          model: productVO?.productModel,
          code: productVO?.productCode,
          kw: searchResult?.globalSearchKeyword,
          cp: searchResult?.currePage,
          ix: 0,
          no: purchaseCount,
          price: totalPrices,
          track_zone: track_zone,
          type: 'main_products',
          kind: productVO.productStockStatus === 'yes' ? 'cart' : 'order',
          ixz: index,
          rs_log,
          parameter_condition: newParameterCondition,
        };
        if (suggest) {
          Object.assign(params, {
            suggest,
          });
        }
        buriedPoint({
          op: 'ADD_CART',
          data: params,
        });
      });
  }

  return productVO.productStockStatus === 'yes' ? (
    <button
      ref={addBtnRef}
      className="mb-[6px] h-[32px] w-full rounded-[6px] bg-[#0093E6] text-[12px] text-[white] hover:bg-[#47B2ED]"
      type="primary"
      onClick={addCart}
      data-spm="iad"
      data-custom-data={JSON.stringify({
        productType: isMro ? 'mro' : 'electronic',
        productCode: productVO?.productCode,
      })}
    >
      加入购物车
    </button>
  ) : (
    <button
      ref={addBtnRef}
      className={`${productVO?.productCycle === 'stop_product' ? 'bg-[#BABABA] text-[#fff]' : 'border-[1px] border-solid border-[#1FA0E8] bg-[#EDF9FF] hover:border-[#0093E6] hover:bg-[#0093E6] hover:text-[white]'} mb-[6px] block h-[32px] w-full rounded-[6px] text-[12px] text-[#1FA0E8]`}
      onClick={addCart}
    >
      我要订货
    </button>
  );
}

export function addCartBall(target, cb) {
  try {
    const ball = document.createElement('div');
    ball.classList = ['absolute z-[99999] size-[16px] text-[12px] text-center text-[white] bg-[#ff3300] rounded-[8px]'];
    const id = Utils.getUuid();
    ball.id = `add_ball_${id}`;
    ball.innerHTML = '+1';
    document.body.appendChild(ball);
    const targetRect = target.getBoundingClientRect();
    ball.style.top = `${targetRect.top + window.scrollY}px`;
    ball.style.left = `${targetRect.left + 124 + window.scrollX}px`;
    const cartBtn = document.querySelector('#cart');
    const offset = cartBtn?.getBoundingClientRect();
    const bool = new Parabola({
      el: `#add_ball_${id}`,
      offset: [offset?.left + offset.width - 16 - targetRect.left - 124, offset?.top - targetRect.top],
      duration: 1000,
      curvature: 0.0025,
      callback() {
        const list = document.querySelectorAll(`#add_ball_${id}`);
        if (list?.length > 0) {
          list.forEach((item) => {
            item.remove();
          });
        }
        cb();
      },
    });
    bool.start();
  } catch (e) {
    console.error('addBall', e);
  }
}
